import SearchNoResults from './SearchNoResults.component';

export default SearchNoResults;
